//#region Libraries
import styled from "styled-components";
//#endregion

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 5px;
    background-color: var(--light-1);
`;
export const Content = styled.section`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    gap: 10px;
    width: ${({ width = "unset" }) => width};
    border: 1px solid var(--light-gray-4);
    border-radius: 4px;
    cursor: default;
    &.small {
        padding: 10.3px 15px;
    }
    &.error {
        border-color: var(--red-2); 
    }
`;
export const Text = styled.span`
    font-weight: 600;
    font-size: 13px;
    color: var(--light-gray-5);
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
export const Button = styled.span`
    font-size: 12px;
    color: var(--purple-2);
    font-weight: bold;
    cursor: pointer;
    &.error { color: var(--red-2); }
`;